export const sharedInitialValues = (initialValues, noProduct = false) => ({
    personalInformation: {
        name: initialValues.first_name || '',
        surname: initialValues.last_name || '',
        email: initialValues.email || '',
        phone: initialValues.phone || '',
        address: initialValues.address_1 || '',
        houseNumber: initialValues.address_2 || '',
        city: initialValues.city || '',
        zipCode: initialValues.postcode || '',
        pesel: initialValues.pesel || '',
    },
    ...(noProduct
        ? {}
        : {
              privacy: false,
              agreement_one: false,
              agreement_two: false,
              agreement_three: false,
          }),
});
